"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EnquiryAccessibilityRequirement;
(function (EnquiryAccessibilityRequirement) {
    EnquiryAccessibilityRequirement["Unknown"] = "Unknown";
    EnquiryAccessibilityRequirement["None"] = "None";
    EnquiryAccessibilityRequirement["AccessibleUnit"] = "AccessibleUnit";
})(EnquiryAccessibilityRequirement = exports.EnquiryAccessibilityRequirement || (exports.EnquiryAccessibilityRequirement = {}));
